import API from '@/api';

const GET_CHALLENGE_RESULTS = 'GET_CHALLENGE_RESULTS';
const GET_CHALLENGE_RESULTS_SUCCESS = 'GET_CHALLENGE_RESULTS_SUCCESS';
const GET_CHALLENGE_RESULTS_FAILED = 'GET_CHALLENGE_RESULTS_FAILED';

// Enabled the module to be namespaced
const namespaced = true;

// Challenges initial state
const state = {
  loading: false,
  challengeResultList: {},
};

const emptyState = {
  loading: false,
  challengeResultList: {},
};

// Challenges getters
const getters = {
  getChallengeResults: (state) => {
    return state.challengeResultList;
  },
};

// Challenges actions
const actions = {
  // * getResultList fetches a list of challenge results
  async getResultList({ commit }, payload) {
    let response;

    commit(GET_CHALLENGE_RESULTS);

    try {
      response = await API.challenges.challengeResults(payload);

      if (response?.status >= 400 || response?.data === 'Network Error' || !response?.data) {
        response.data = [];
      }
    } catch (err) {
      response = err;
    }

    //* Current not getting to this point if I return above
    return new Promise((resolve, reject) => {
      // console.log('response:', response);
      if (!response.data || response.status >= 400) {
        commit(GET_CHALLENGE_RESULTS_FAILED);
        reject(response);
      } else {
        resolve(response.data);
        commit(GET_CHALLENGE_RESULTS_SUCCESS, response.data);
        return response;
        // * Return GET data with promise
      }
    });
  },
};

// Challenges mutations
const mutations = {
  [GET_CHALLENGE_RESULTS](state) {
    state.loading = true;
  },

  [GET_CHALLENGE_RESULTS_SUCCESS](state, challengeResultList) {
    state.challengeResultList = challengeResultList?.challenge_results;
    state.loading = false;
  },

  [GET_CHALLENGE_RESULTS_FAILED](state) {
    state.loading = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
